import { autoinject, Aurelia, observable } from 'aurelia-framework';
import { HttpClient, HttpResponseMessage, HttpRequestMessage } from 'aurelia-http-client';
import { Router } from 'aurelia-router';
import { PageMessageService } from "../services/page-message-service";
import { AppMessageService } from "../services/app-message-service";
import { BusyService } from "./busy-service";
import environment from '../environment';

@autoinject()
export class WebApiService {

    @observable()
    containerId: string;    //used by message service to display message in the correct component view.
    containerIdChanged(newValue) {
        this.appMessageService.containerId = newValue;
    }

    private baseApiUrl = environment.apiRoot;

    constructor(private aurelia: Aurelia, private router: Router,
        private busyService: BusyService,
        private pageMessageService: PageMessageService,
        private appMessageService: AppMessageService) {
        (<any>this.aurelia).subscribe('router:navigation:complete', msg => this.onNavigationComplete(msg));
    }

    private getHttpClient(): HttpClient {
        var pageMessageService = this.pageMessageService;
        var appMessageService = this.appMessageService;
        var router = this.router;
        var webApiService = this;
        let client = new HttpClient()
            .configure(x => {
                x.withHeader('Accept', 'application/json');
                x.withHeader('X-Ajax-Request', 'true');
                x.withHeader('X-Host-Url', window.location.href);
                x.withInterceptor({
                    request(request) {
                        return request;
                    },
                    response(response) {
                        //check for redirect
                        if (response.statusCode === 204) {
                            var location = response.headers.get("Location");
                            if (location) {
                                webApiService.redirect(location);
                            }
                        }

                        //check for app messages
                        appMessageService.handleHttpResponse(response);

                        return response;
                    },
                    responseError(responseError): Promise<HttpResponseMessage> {
                        //check for 404
                        if (responseError.statusCode === 404) {
                            webApiService.redirect("not-found");
                            return responseError.response;
                        }


                        var error = normalizeError(responseError);
                        appMessageService.addErrorMessage(error.errorMessage);
                        //scroll to top of page to ensure error is visible
                        window.scrollTo(0, 0);
                        throw error;
                    },
                    requestError(requestError): Promise<HttpRequestMessage> {
                        appMessageService.addErrorMessage(requestError.message);
                        throw requestError.message;
                    }
                });
            });
        return client;


        function normalizeError(error: HttpResponseMessage): any {
            //TODO: if error is in unexpected form from server, then put into standard shape
            try {
                return JSON.parse(error.response);
            } catch (e) {
                return {
                    errorMessage: "We are experiencing issues.  Please try again later."
                };
            }
        }
    }

    private getApiPath(controller: string, action: string, parameters?: { [key: string]: any }) {
        let fragment = `${this.baseApiUrl}/${controller}/${action}`;
        if (parameters) {
            fragment += "?";
            for (let key of Object.keys(parameters)) {
                fragment += `${key}=${parameters[key]}&`;
            }
        }
        return fragment;
    }

    public get(controller: string, action: string, parameters?: { [key: string]: any }): Promise<any> {
        ////  from UI element
        //if (event instanceof UIEvent) {
        //    this.appMessageService.clearNonPersistentMessages();
        //}

        let client = this.getHttpClient();
        return client.get(this.getApiPath(controller, action, parameters));
    }



    public getUrl(controller: string, action: string, parameters?: { [key: string]: any }) {
        return this.getApiPath(controller, action, parameters);
    }

    public post(controller: string, action: string, parameters?: { [key: string]: any }): Promise<any> {
        ////clear messages if this is trigger from UI element
        //if (event instanceof UIEvent) {
        //    this.appMessageService.clearNonPersistentMessages();
        //}

        let client = this.getHttpClient();
        return client.post(this.getApiPath(controller, action), parameters);
    }

    // submit the request, parse the response and handle error notifications
    public submit(controller: string, action: string, parameters?: { [key: string]: any }): Promise<any> {
        //clear messages if this is trigger from UI element
        this.busyService.on();


        //if (event instanceof UIEvent) {
        //    this.appMessageService.clearNonPersistentMessages();
        //}

        let client = this.getHttpClient();
        return client.post(this.getApiPath(controller, action), parameters)
            .finally(() => this.busyService.off());
    }

    public redirectUrl: string;

    private redirect(url) {

        //for now assume that all redirects are route fragments
        if (this.router.isNavigating) {
            this.redirectUrl = url;
        } else {
            if (url.indexOf("/") === 0 || url.indexOf("http")) {
                window.location.href = url;
            } else {
                this.router.navigate(url);
            }
        }
    }

    onNavigationComplete(msg) {
        if (!msg.result.completed) {
            return;
        }

        if (this.redirectUrl) {
            this.router.navigate(this.redirectUrl);
        }
    }

}